var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pixelId)?_c('img',{staticStyle:{"display":"none"},attrs:{"height":"1","width":"1","src":("https://www.facebook.com/tr?id=" + _vm.pixelId + "&ev=PageView&noscript=1"),"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }